import { useState } from "react";
import {
  UsersApi,
  UsersResetSyncItemsPostRequest,
  RequestResetSyncItemsRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiResetSyncItems = () => {
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const resetSyncItems = async (req: RequestResetSyncItemsRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: UsersResetSyncItemsPostRequest = {
        req,
      };

      const api = new UsersApi(config);
      return await api.usersResetSyncItemsPost(request);
    } catch (err) {
      setError("同期中状態の解除に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { resetSyncItems, error, isLoading };
};
